import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import userSlice from 'src/store/userSlice';
import sitesSlice from 'src/store/siteSlice';
import defaultSettingsPageSlice from 'src/store/defaultSettingsPageSlice';
import errorBoundarySlice from 'src/store/errorBoundarySlice';
import toastsSlice from 'src/store/toastsSlice';
import taskConfigPageSlice from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import siteConfigPageSlice from 'src/store/adminConfigPageSlice/siteConfigPageSlice/siteConfigPageSlice';
import regionTasksConfigPageSlice from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import adminConfigPageSlice from 'src/store/adminConfigPageSlice/adminConfigPageSlice';
import jobConfigPageSlice from 'src/store/jobConfigPageSlice/jobConfigPageSlice';
import correspondenceSlice from 'src/store/correspondenceSlice';
import createNewJobSlice from 'src/store/createNewJobSlice';
import emailDistributionPageSlice from 'src/store/emailDistributionPageSlice';
import newJmrPageSlice from 'src/store/newJmrPageSlice';
import placementDetailsPageSlice from 'src/store/placementDetailsPageSlice/placementDetailsPageSlice';
import placementOverviewPageSlice from 'src/store/placementOverviewPageSlice';
import updateShiftsSlice from 'src/store/updateShiftsPageSlice';
import updateSiteCapacitySlice from 'src/store/updateSiteCapacitySlice/updateSiteCapacitySlice';
import modificationsSlice from 'src/store/modificationsSlice';

export const reducers = {
  user: userSlice,
  sites: sitesSlice,
  defaultSettingsPage: defaultSettingsPageSlice,
  errorBoundary: errorBoundarySlice,
  toasts: toastsSlice,
  taskConfigPage: taskConfigPageSlice,
  siteConfigPage: siteConfigPageSlice,
  jobConfigPage: jobConfigPageSlice,
  createNewJobPage: createNewJobSlice,
  regionTasksConfigPage: regionTasksConfigPageSlice,
  adminConfigPage: adminConfigPageSlice,
  updateShiftsPage: updateShiftsSlice,
  emailDistributionPage: emailDistributionPageSlice,
  updateSiteCapacityPage: updateSiteCapacitySlice,
  placementOverviewPage: placementOverviewPageSlice,
  newJmrPage: newJmrPageSlice,
  placementDetailsPage: placementDetailsPageSlice,
  correspondence: correspondenceSlice,
  modifications: modificationsSlice,
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // to allow non serializable objects to be stored in redux (eg: Map, Set, classes etc.)
    }),
});
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
